<script>
	import timezonesStore from "$stores/timezones";
	import { memoizeAsync } from "$misc/utils";

	export let name = "timezone";
	export let value = "";

	const getTimezones = memoizeAsync(async (value) => {
		const { user, timezones } = await $timezonesStore;
		return { user: value || user, timezones: Object.entries(timezones) };
	});

	const timezones = getTimezones(value);
</script>

<div class="form-group">
	<label for={name}>Timezone</label>

	{#await timezones then { user, timezones }}
		<select id={name} {name} class="form-control" required="true">
			{#each timezones as [value, name]}
				<option selected={user === value} {value}>{name}</option>
			{/each}
		</select>
	{:catch error}
		<div class="text text--muted" style="margin-top: 0.55em">
			Unable to retrieve list of countries:
			{error.message}
		</div>
	{/await}
</div>

<style>
	.form-group select {
		height: 2.25em;
	}
</style>
